import { skipToken } from "@reduxjs/toolkit/query/react";
import { getQueryStatus } from "@sscs/utils";
import { useGetProjectsSearchQuery } from "Services";

const useProjects = (
  groupId: string | undefined,
  selectedProjectName: string,
  selectedPackageName: string,
) => {
  const { data, isFetching, isLoading, error, isError } =
    useGetProjectsSearchQuery(
      groupId
        ? {
            groupId,
            searchName: "",
          }
        : skipToken,
    );

  const queryStatus = getQueryStatus({
    data,
    isLoading,
    isFetching,
    error,
    isError,
  });

  const selectedProject = data?.projects.find(
    (project) => project.name === selectedProjectName,
  );

  const selectedProjectPackageNames = selectedProject?.packages.map(
    (projectPackage) => projectPackage.name,
  );

  const selectedPackageId: string | undefined = selectedProject?.packages.find(
    (projectPackage) => projectPackage.name === selectedPackageName,
  )?.package_id;

  const selectedProjectId: string | undefined = selectedProject?.project_id;

  return {
    projectNames: data?.projects.map((project) => project.name),
    queryStatus,
    selectedProjectPackageNames,
    selectedPackageId,
    selectedProjectId,
  };
};

export default useProjects;
